import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DischargedPanel from '../pages/discharged/DischargedPanel';
import AdmittedPanel from '../pages/admitted/AdmittedPanel';
import EmergencyPanel from '../pages/emergency/EmergencyPanel';
import HighCostPanel from '../pages/high-cost/HighCostPanel';
import HighRiskPanel from '../pages/high-risk/HighRiskPanel';
import { CLINICAL_TABS } from '../common/constants';

// Helper component for tab panels
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`clinical-tabpanel-${index}`}
      aria-labelledby={`clinical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

function ClinicalTabs() {
  const { t } = useTranslation();
  const [value, setValue] = useState(CLINICAL_TABS.DISCHARGED);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={value} onChange={handleChange} aria-label="Clinical Information tabs">
        <Tab
          label={t("Main.Discharged.Discharged")}
          id="clinical-tab-0"
          aria-controls="clinical-tabpanel-0"
        />
        <Tab
          label={t("Main.Admitted.Admitted")}
          id="clinical-tab-1"
          aria-controls="clinical-tabpanel-1"
        />
        <Tab
          label={t("Main.Emergency.Emergency")}
          id="clinical-tab-2"
          aria-controls="clinical-tabpanel-2"
        />
        <Tab
          label={t("Main.HighCost.HighCost")}
          id="clinical-tab-3"
          aria-controls="clinical-tabpanel-3"
        />
        <Tab
          label={t("Main.HighRisk.HighRisk")}
          id="clinical-tab-4"
          aria-controls="clinical-tabpanel-4"
        />
      </Tabs>

      <TabPanel value={value} index={CLINICAL_TABS.DISCHARGED}>
        <DischargedPanel />
      </TabPanel>
      <TabPanel value={value} index={CLINICAL_TABS.ADMITTED}>
        <AdmittedPanel />
      </TabPanel>
      <TabPanel value={value} index={CLINICAL_TABS.EMERGENCY}>
        <EmergencyPanel />
      </TabPanel>
      <TabPanel value={value} index={CLINICAL_TABS.HIGH_COST}>
        <HighCostPanel />
      </TabPanel>
      <TabPanel value={value} index={CLINICAL_TABS.HIGH_RISK}>
        <HighRiskPanel />
      </TabPanel>
    </Box>
  );
}

export default ClinicalTabs;
